import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import ParcelCheckout from "../../components/checkout/parcel";
import MetaData from "../meta-data";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import AuthGuard from "../../components/route-guard/AuthGuard";
import ItemCheckout from "../../components/checkout/item-checkout";
import CustomAlert from "../../components/alert/CustomAlert";
import { getCartListModuleWise } from "../../helper-functions/getCartListModuleWise";
import PrescriptionCheckout from "../../components/checkout/Prescription";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";


const CheckOutPage = () => {
    const { configData, landingPageData, loading } = useConfigData();
    const router = useRouter();
    const [rendered, setIsRendered] = useState(false);
    const { page, store_id, id } = router.query;
    
    const {
        cartList: aliasCartList,
        campaignItemList,
        buyNowItemList,
        totalAmount,
    } = useSelector((state) => state.cart);
    
    const cartList = getCartListModuleWise(aliasCartList);

    useEffect(() => {
        setIsRendered(true);
    }, []);

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                Loading...
            </div>
        );
    }

    // Use useEffect to handle redirects to avoid React warnings
  useEffect(() => {
    if (router.isReady) {
      if ((page === "cart" && cartList.length === 0) ||
          (page === "campaign" && campaignItemList.length === 0) ||
          (page === "buy_now" && buyNowItemList.length === 0) ||
          !page) {
        router.push("/home", undefined, { shallow: true });
      }
    }
  }, [router.isReady, page, cartList.length, campaignItemList.length, buyNowItemList.length, router]);

  const handleEmpty = () => {
    // Return null if we should redirect (handled by useEffect)
    if (router.isReady) {
      if ((page === "cart" && cartList.length === 0) ||
          (page === "campaign" && campaignItemList.length === 0) ||
          (page === "buy_now" && buyNowItemList.length === 0)) {
        return null;
      }
    }
  };

  return (
    <>
      <CssBaseline />
      <SEO
        title={configData ? `Checkout` : "Loading..."}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        <AuthGuard from="checkout">
          {rendered && (
            <>
              {page === "parcel" && <ParcelCheckout />}
              {page === "prescription" && (
                <PrescriptionCheckout storeId={store_id} />
              )}
              {page === "campaign" && campaignItemList.length > 0 && (
                <ItemCheckout
                  router={router}
                  configData={configData}
                  page={page}
                  cartList={cartList}
                  campaignItemList={campaignItemList}
                  totalAmount={totalAmount}
                />
              )}
              {page === "cart" && cartList.length > 0 && (
                <ItemCheckout
                  router={router}
                  configData={configData}
                  page={page}
                  cartList={cartList}
                  campaignItemList={campaignItemList}
                  totalAmount={totalAmount}
                />
              )}
              {page === "buy_now" && (
                <ItemCheckout
                  router={router}
                  configData={configData}
                  page={page}
                  cartList={buyNowItemList}
                  campaignItemList={campaignItemList}
                  totalAmount={totalAmount}
                />
              )}
              {handleEmpty()}
            </>
          )}
        </AuthGuard>
      </MainLayout>
    </>
  );
};

export default CheckOutPage;
